import { Route, Routes } from "react-router-dom";
import Layout from "./components/Layout";
import About from "./pages/About";
import CommunityProfile from "./pages/CommunityProfile";
import Directory from "./pages/Directory";
import GlobalMap from "./pages/GlobalMap";
import Guild from "./pages/Guild";
import GuildMap from "./pages/GuildMap";
import Home from "./pages/Home";
import NotFound from "./pages/NotFound";
import Privacy from "./pages/Privacy";
import Submit from "./pages/Submit";
import Terms from "./pages/Terms";

const App = () => (
  <Layout>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/directory" element={<Directory />} />
      <Route path="/map" element={<GlobalMap />} />
      <Route path="/guilds/:guildId" element={<Guild />} />
      <Route path="/guilds/:guildId/map" element={<GuildMap />} />
      <Route path="/communities/:communityId" element={<CommunityProfile />} />
      <Route path="/submit" element={<Submit />} />
      <Route path="/about" element={<About />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  </Layout>
);

export default App;
